export const formatCategoryParentPath = (fullName, name) => {
  if (!fullName) return '';

  const parts = String(fullName)
    .split('>')
    .map((segment) => segment.trim())
    .filter(Boolean);

  if (!parts.length) return '';

  if (name && parts[parts.length - 1] === name) {
    return parts.slice(0, -1).join(' / ');
  }

  return parts.join(' / ');
};

export const formatCategoryLabel = ({ name, fullName } = {}) => {
  if (!name) return '';

  const parentPath = formatCategoryParentPath(fullName, name);
  if (!parentPath) return name;

  const parentSegments = parentPath.split(' / ').filter(Boolean);
  const immediateParent = parentSegments[parentSegments.length - 1];

  return immediateParent ? `${name} in ${immediateParent}` : name;
};

export const formatCategoryChipParts = ({ name, fullName } = {}) => {
  if (!name) {
    return { primary: '', secondary: null };
  }

  const parentPath = formatCategoryParentPath(fullName, name);
  if (!parentPath) {
    return { primary: name, secondary: null };
  }

  const parentSegments = parentPath.split(' / ').filter(Boolean);
  const immediateParent = parentSegments[parentSegments.length - 1];

  return {
    primary: name,
    secondary: immediateParent ? ` in ${immediateParent}` : null,
  };
};

export default formatCategoryLabel;
